import React, {useState} from 'react';
import {OutsideToastsComponent} from "./OutsideToastsComponent";
import {ContextToastsComponent, ToastsContext} from "./ContextToastsComponent";
import {ReduxToastsComponent} from "./ReduxToastsComponent";


function App() {
  const [toastsVisible, setToastsVisible] = useState(false);

  const [contextToastsVisible, setContextToastsVisible] = useState(false);
  const [contextToasts, setContextToasts] = useState([]);


  return (
    <div>
      <h2>Inside React app</h2>
      <button onClick={e => {
        e.stopPropagation();
        setToastsVisible(toastsVisible => !toastsVisible);
      }}>
        {toastsVisible? 'Hide' : 'Show'} toasts
      </button>
      {toastsVisible && (
        <div
          onClick={() => alert('I was clicked! Even from outside my DOM which means event propagates properly')}>
          <OutsideToastsComponent />
        </div>
      )}
      <h3>
        Context toasts
      </h3>
      <button onClick={e => {
        e.stopPropagation();
        setContextToastsVisible(contextToastsVisible => !contextToastsVisible);
      }}>
        {contextToastsVisible? 'Hide' : 'Show'} toasts
      </button>
      <ToastsContext.Provider value={{
        toasts: contextToasts,
        addToast: () => setContextToasts(toasts => [...toasts, new Date().getTime()]),
        toastsVisible: contextToastsVisible,
        removeToast: (id) => setContextToasts(toasts => toasts.filter(toast => toast !== id))
      }}>
        <ContextToastsComponent />
      </ToastsContext.Provider>
      <h3>
        Redux toasts
      </h3>
      <ReduxToastsComponent />
    </div>
  );
}

export default App;
